import { render, staticRenderFns } from "./fisDetay.vue?vue&type=template&id=623d3be6&scoped=true&"
import script from "./fisDetay.vue?vue&type=script&lang=js&"
export * from "./fisDetay.vue?vue&type=script&lang=js&"
import style0 from "./fisDetay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./fisDetay.vue?vue&type=style&index=1&lang=css&"
import style2 from "./fisDetay.vue?vue&type=style&index=2&id=623d3be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d3be6",
  null
  
)

export default component.exports